import React, {Component} from "react"
import PropTypes from 'prop-types'
import {connect} from "react-redux"
import {Fade, Glyphicon, Grid} from 'react-bootstrap'
import {Redirect} from 'react-router-dom'
import Header from "../components/Header"
import Footer from "../components/Footer"
import ConfirmModal from "../components/ConfirmModal"
import {hideModal} from "../actions/modal"
import {changePassword, forgottenPassword, sessionInfo, sessionLogin, sessionLogout} from "../actions/session"
import {loadGeneralEnums} from "../actions/enums"
import {resetAlerts} from "../actions"
import routes from "../routes"
import * as Acl from "../utils/acl"

class App extends Component {

	alertsTimeout = null;
	sessionInfoInterval = null;

	componentWillMount() {
		this.props.sessionInfo();
	}

	componentWillReceiveProps(nextProps) {
		if (Acl.changedLoggedIn(nextProps, this.props)) {
			// just logged out
			if (this.sessionInfoInterval) {
				clearInterval(this.sessionInfoInterval)
			}
		} else if (Acl.changedLoggedIn(this.props, nextProps)) {
			// just logged in
			this.props.loadGeneralEnums(["dog", "role", "user"]);
			this.sessionInfoInterval = setInterval(this.props.sessionInfo, 10 * 60000)
			// this.forceUpdate()
		}
	}

	handleDismissClick = e => {
		this.props.resetAlerts();
		if (this.alertsTimeout) {
			clearTimeout(this.alertsTimeout)
		}
		if (e) {
			e.preventDefault()
		}
	};

	renderAlerts() {
		const {alerts} = this.props;

		const items = [];
		if (alerts.messages.length) {
			for (let k in alerts.messages) {
				if (alerts.messages.hasOwnProperty(k)) {
					items.push(<div key={k}>{alerts.messages[k]}</div>)
				}
			}
			if (this.alertsTimeout) {
				clearTimeout(this.alertsTimeout)
			}
			if (alerts.type === "success") {
				this.alertsTimeout = setTimeout(this.props.resetAlerts, items.length * 5000)
			}
		}

		return (
			<Fade in={alerts.messages.length > 0}>
				<div className="alert-top">
					<div className={"alert-inner alert alert-" + alerts.type + (alerts.messages.length ? "" : " hidden")}>
						<button className="pull-right btn btn-xs" onClick={this.handleDismissClick}>x</button>
						{items}
					</div>
				</div>
			</Fade>
		)
	}

	render() {
		const {modal, hideModal, session, location} = this.props;
		let token = null;
		if (Acl.isLoggedIn(session)) {
			if (location.pathname && location.pathname.indexOf('/prihlaseni') >= 0) {
				return <Redirect to={{pathname: '/'}}/>
			}
		} else {
			if (!session.hasFetchedInfo) {
				return <div className="loading-text"><Glyphicon glyph="refresh" className="spin"/> Aplikace se nahrává ...</div>
			}
			if (location.pathname && location.pathname.indexOf('/prihlaseni/') >= 0) {
				token = location.pathname.substr('/prihlaseni/'.length);
			}
			if (!token && (!location.pathname || location.pathname.indexOf('/prihlaseni') < 0)) {
				return <Redirect to={{pathname: '/prihlaseni', state: {from: this.props.location}}}/>
			}
		}

		return (
			<div>
				<Header onLogin={this.props.sessionLogin} onLogout={this.props.sessionLogout}
					onChangePassword={this.props.changePassword} onForgottenPassword={this.props.forgottenPassword}
					session={session} token={token} history={this.props.history}/>
				{this.renderAlerts()}
				<main className={"main-content"} id={"content-container"}>
					<Grid>
						{routes}
					</Grid>
				</main>
				<Footer/>
				{modal.isShowing && <ConfirmModal onCancel={hideModal} {...modal} />}
			</div>
		)
	}
}

App.propTypes = {
	headerContent: PropTypes.node,
	loadGeneralEnums: PropTypes.func.isRequired,
	sessionInfo: PropTypes.func.isRequired,
	sessionLogin: PropTypes.func.isRequired,
	sessionLogout: PropTypes.func.isRequired,
	changePassword: PropTypes.func.isRequired,
	forgottenPassword: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired,
	alerts: PropTypes.object.isRequired,
	resetAlerts: PropTypes.func.isRequired,
	modal: PropTypes.object.isRequired,
	hideModal: PropTypes.func.isRequired,
	// Injected by React Router
	children: PropTypes.node
};

const mapStateToProps = (state, ownProps) => ({
	alerts: state.alerts,
	modal: state.modal,
	session: state.session,
});

export default connect(mapStateToProps, {
	loadGeneralEnums,
	sessionInfo,
	sessionLogin,
	sessionLogout,
	changePassword,
	forgottenPassword,
	resetAlerts,
	hideModal
})(App)



// WEBPACK FOOTER //
// ./src/containers/App.js